import { UPDATE_CALLEE_NUMBER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function updateCalleeNumber(calleeData) {
  return callingAPIMethodWithQueue(UPDATE_CALLEE_NUMBER, calleeData);
}